import { defaultTo } from 'aa_common/front-end/helpers'
import { AssetLedger } from 'common/models'
import isEqual from 'lodash/isEqual'
import { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { selectMasterData } from 'store/masterData/selectors'

export const useSetOriginalLedgerInfo = (ledger: AssetLedger) => {
  const masterData = useSelector(selectMasterData, isEqual)
  const depreciationMethods = useMemo(
    () => defaultTo(masterData?.depreciation_method, []),
    [masterData?.depreciation_method]
  )

  useEffect(() => {
    if (ledger.original_depreciation_method_code) {
      const originalDepreciationMethod = depreciationMethods.find(
        dMethod => dMethod.code === ledger.original_depreciation_method_code
      )
      ledger.original_depreciation_method_name = originalDepreciationMethod?.name_jp
    }
  }, [ledger, depreciationMethods])
}
